import { createSelector } from '@ngrx/store';
import { getMessagesState } from '../messages.selectors';

export const gbmConversationsState = createSelector(
  getMessagesState,
  (state) => state.gbmConversationsState
);
export const conversationsState = createSelector(
  gbmConversationsState,
  (gbmConversations) => gbmConversations.conversations
);
export const conversationsData = createSelector(
  conversationsState,
  (conversations) => conversations.data
);
export const conversationsIsLoading = createSelector(
  conversationsState,
  (conversations) => conversations.isLoading
);
export const conversationsSuccess = createSelector(
  conversationsState,
  (conversations) => conversations.success
);
export const conversationsError = createSelector(
  conversationsState,
  (conversations) => conversations.error
);
export const conversationsHasBeenFetched = createSelector(
  conversationsState,
  (conversations) => conversations.fetched
);

export const seletedConversationId = createSelector(
  getMessagesState,
  (state) => state.gbmConversationsState.seletedConversationId
);
export const messagesState = createSelector(
  getMessagesState,
  (state) => state.gbmConversationsState.messages
);

export const messagesData = createSelector(
  messagesState,
  (messages) => messages.data
);
export const messagesLoading = createSelector(
  messagesState,
  (messages) => messages.isLoading
);
export const messagesError = createSelector(
  messagesState,
  (messages) => messages.error
);
export const messagesSuccess = createSelector(
  messagesState,
  (messages) => messages.success
);
